import React, { useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import AxiosController from "../authentication/AxiosController";

const IncreaseBalanceModal = ({ show, handleClose, onSuccess }) => {
  const { slug, lang } = useParams();
  const [_] = useTranslation("global");
  const token = localStorage.getItem("token");

  const [userId, setUserId] = useState("");
  const [amount, setAmount] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [showConfirmation, setShowConfirmation] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setError("");

    if (!userId || !amount) {
      setError(_("panel.fillAllFields"));
      return;
    }

    if (parseFloat(amount) <= 0) {
      setError(_("panel.invalidAmount"));
      return;
    }

    // Show confirmation step
    setShowConfirmation(true);
  };

  const handleConfirm = () => {
    setLoading(true);
    setError("");

    AxiosController.post(
      `api/${slug}/${lang}/users/increase-balance`,
      {
        user_id: userId,
        amount: parseFloat(amount),
      },
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    )
      .then((res) => {
        setLoading(false);
        resetForm();
        if (onSuccess) {
          onSuccess(res.data);
        }
        handleClose();
      })
      .catch((e) => {
        setLoading(false);
        setError(e.response?.data?.message || _("panel.errorOccurred"));
      });
  };

  const resetForm = () => {
    setUserId("");
    setAmount("");
    setShowConfirmation(false);
    setError("");
  };

  const handleModalClose = () => {
    resetForm();
    handleClose();
  };

  const handleBackToForm = () => {
    setShowConfirmation(false);
  };

  return (
    <Modal show={show} onHide={handleModalClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>{_("panel.increaseBalance")}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {!showConfirmation ? (
          <Form onSubmit={handleSubmit}>
            <Form.Group className="mb-3">
              <Form.Label>{_("panel.userId")}</Form.Label>
              <Form.Control
                type="number"
                placeholder={_("panel.enterUserId")}
                value={userId}
                onChange={(e) => setUserId(e.target.value)}
                required
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>{_("panel.amount")}</Form.Label>
              <Form.Control
                type="number"
                step="0.01"
                placeholder={_("panel.enterAmount")}
                value={amount}
                onChange={(e) => setAmount(e.target.value)}
                required
              />
            </Form.Group>

            {error && (
              <div className="alert alert-danger" role="alert">
                {error}
              </div>
            )}

            <div className="d-flex justify-content-end gap-2">
              <Button variant="secondary" onClick={handleModalClose}>
                {_("panel.cancel")}
              </Button>
              <Button
                type="submit"
                style={{
                  backgroundColor: "rgb(89, 198, 201)",
                  border: "none",
                }}
              >
                {_("panel.next")}
              </Button>
            </div>
          </Form>
        ) : (
          <div>
            <h5 className="mb-4">{_("panel.confirmBalanceIncrease")}</h5>
            <div className="mb-3 p-3 bg-light rounded">
              <p className="mb-2">
                <strong>{_("panel.userId")}:</strong> {userId}
              </p>
              <p className="mb-0">
                <strong>{_("panel.amount")}:</strong> {amount}
              </p>
            </div>

            {error && (
              <div className="alert alert-danger" role="alert">
                {error}
              </div>
            )}

            <div className="d-flex justify-content-end gap-2">
              <Button variant="secondary" onClick={handleBackToForm}>
                {_("panel.back")}
              </Button>
              <Button
                onClick={handleConfirm}
                disabled={loading}
                style={{
                  backgroundColor: "rgb(89, 198, 201)",
                  border: "none",
                }}
              >
                {loading ? _("panel.loading") : _("panel.confirm")}
              </Button>
            </div>
          </div>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default IncreaseBalanceModal;
